import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {AssetSchema} from './asset'
import {LinkSchema} from './link'
import {PrimerComponentTimelineSchema} from './primerComponentTimeline'
import {AnimatedVideoSchema} from './animatedVideo'
import {safeOptional} from '../../safe-optional'

export const PrimerComponentRiverBreakoutSchema = buildEntrySchemaFor('primerComponentRiverBreakout', {
  fields: z.lazy(() =>
    z.object({
      a11yHeading: z.string(),
      headingLevel: z.enum(['h2', 'h3']).optional(),
      text: RichTextSchema,
      trailingComponent: safeOptional(PrimerComponentTimelineSchema),
      callToAction: safeOptional(LinkSchema),
      callToActionVariant: z.enum(['default', 'accent']).optional(),
      image: safeOptional(AssetSchema),
      imageAlt: z.string().optional(),
      animatedVideo: safeOptional(AnimatedVideoSchema),
      hasShadow: z.boolean().optional(),
      htmlId: z.string().optional(),
    }),
  ),
})

export type PrimerComponentRiverBreakout = z.infer<typeof PrimerComponentRiverBreakoutSchema>

export function isRiverBreakout(river: unknown): river is PrimerComponentRiverBreakout {
  return PrimerComponentRiverBreakoutSchema.safeParse(river).success
}
